import _ from 'lodash'
import { getI18nBase } from '../i18n'

const i18nBase = getI18nBase('components/crowdfunding_category')

export const getTranslatedCategoryList = state => {
  const catList = _.get(state, 'categoryData', [])
  const options = catList.map(listItem => {
    return {
      key: listItem.key,
      value: listItem.key,
      label: i18nBase(`category.${listItem.key}.name`),
      sortKey: i18nBase(`category.${listItem.key}.sortkey`),
    }
  })
  options.sort((catA, catB) => catA.sortKey - catB.sortKey)
  return options
}

export const isValidCategory = (state, value = '') => {
  return _.find(
    getTranslatedCategoryList(state),
    listItem => listItem.value === value
  )
}

export const getCategoryLabel = (state, value = '') => {
  const category =
    _.find(
      getTranslatedCategoryList(state),
      listItem => listItem.value === value
    ) || {}
  const categoryLabel = _.get(category, 'label')
  return categoryLabel
}

export const getCategoryDefaultCover = (state, value = '') => {
  const categoryList = _.get(state, 'categoryData', [])
  const selectedCategory = _.find(
    categoryList,
    category => category.key === value
  )

  return selectedCategory && selectedCategory.cover
}

export default {
  getTranslatedCategoryList,
  isValidCategory,
  getCategoryLabel,
  getCategoryDefaultCover,
}
